import React from 'react';
import beinsports from '../assets/chaine/Bein_Sports.png'
import Atresplayer from '../assets/chaine/Canal+.png'
import netflix from '../assets/chaine/Netflix.png'
import primevideo from '../assets/chaine/Prime_Video.png'
import disney from '../assets/chaine/Disney+.png'
import movistarplus from '../assets/chaine/MBC_Group.png'
import tf1 from '../assets/chaine/TF1.png'
import hbomax from '../assets/chaine/HBO_Max.png'
import w9 from '../assets/chaine/W9.png'
import ocs from '../assets/chaine/OCS.png'
import plutotv from '../assets/chaine/Pluto_TV.png'
import appletvplus from '../assets/chaine/Apple_TV.png'
import rmcsport from '../assets/chaine/RMC.png'
import m6 from '../assets/chaine/M6.png'
import tf1seriesfilms from '../assets/chaine/TF1_Films.png'
import hulu from '../assets/chaine/Hulu.png'
import arte from '../assets/chaine/Arte.png'
import Rakuten_TV from '../assets/chaine/DAZN.png'

import film1 from '../assets/film/postermv1.webp'
import film2 from '../assets/film/postermv2.webp'
import film3 from '../assets/film/postermv3.webp'
import film4 from '../assets/film/postermv4.webp'
import film5 from '../assets/film/postermv5.webp'
import film6 from '../assets/film/postermv6.webp'
import film7 from '../assets/film/postermv7.webp'
import film8 from '../assets/film/postermv8.webp'
import film9 from '../assets/film/postermv9.webp'
import film10 from '../assets/film/postermv10.webp'
import film11 from '../assets/film/postermv11.webp'
import film12 from '../assets/film/postermv12.webp'
import film13 from '../assets/film/postermv13.webp'
import film14 from '../assets/film/postermv14.webp'
import film15 from '../assets/film/postermv15.webp'
import film16 from '../assets/film/postermv16.webp'
import film17 from '../assets/film/postermv17.webp'
import film18 from '../assets/film/postermv18.webp'
import film19 from '../assets/film/postermv19.webp'
import film20 from '../assets/film/postermv20.webp'
import film21 from '../assets/film/postermv21.webp'
import film22 from '../assets/film/postermv22.webp'
import film23 from '../assets/film/postermv23.webp'
import film24 from '../assets/film/postermv24.webp'
import film25 from '../assets/film/postermv25.jpg'
import film26 from '../assets/film/postermv26.webp'
import film27 from '../assets/film/postermv27.webp'
import film28 from '../assets/film/postermv28.webp'
import film29 from '../assets/film/postermv29.webp'
import film30 from '../assets/film/postermv30.webp'
import film31 from '../assets/film/postermv31.webp'
import film32 from '../assets/film/postermv32.webp'
import film33 from '../assets/film/postermv33.webp'
import film34 from '../assets/film/postermv1.webp'
import film35 from '../assets/film/postermv2.webp'
import film36 from '../assets/film/postermv3.webp'
import film37 from '../assets/film/postermv4.webp'
import film38 from '../assets/film/postermv5.webp'

export default function Series(){

    // Channel logos data
    const channels = [
        { name: "Netflix", logo: netflix },
        { name: "Disney+", logo: disney },
        { name: "Bein Sports", logo: beinsports },
        { name: "Prime Video", logo: primevideo },
        { name: "HBO Max", logo: hbomax },
        { name: "Apple TV", logo: appletvplus },
        { name: "Hulu", logo: hulu },
        { name: "SkyShowtime", logo: tf1seriesfilms },
        { name: "RTVE", logo: ocs },
        { name: "Cuatro", logo: w9 },
        { name: "Antena3", logo: tf1 },
        { name: "Atresplayer", logo: Atresplayer },
        { name: "art", logo: arte },
        { name: "Pluto TV", logo: plutotv },
        { name: "ESPN", logo: rmcsport },
        { name: "Rakuten TV", logo: Rakuten_TV },
        { name: "M6", logo: m6 },
        { name: "Movistar Plus", logo: movistarplus }
    ];

    // Film posters data
    const films = [
        { id: 1,  poster: film1 },
        { id: 2, poster: film2 },
        { id: 3, poster: film3 },
        { id: 4, poster: film4 },
        { id: 5, poster: film5 },
        { id: 6, poster: film6 },
        { id: 7, poster: film7 },
        { id: 8, poster: film8 },
        { id: 9, poster: film9 },
        { id: 10, poster: film10 },
        { id: 11, poster: film11 },
        { id: 12, poster: film12 },
        { id: 13, poster: film13 },
        { id: 14, poster: film14 },
        { id: 15, poster: film15 },
        { id: 16, poster: film16 },
        { id: 17, poster: film17 },
        { id: 18, poster: film18 },
        { id: 19, poster: film19 },
        { id: 20, poster: film20 },
        { id: 21, poster: film21 },
        { id: 22, poster: film22 },
        { id: 23, poster: film23 },
        { id: 24, poster: film24 },
        { id: 25, poster: film25 },
        { id: 26, poster: film26 },
        { id: 27, poster: film27 },
        { id: 28, poster: film28 },
        { id: 29, poster: film29 },
        { id: 30, poster: film30 },
        { id: 31, poster: film31 },
        { id: 32, poster: film32 },
        { id: 33, poster: film33 },
        { id: 34, poster: film34 },
        { id: 35, poster: film35 },
        { id: 36, poster: film36 },
        { id: 37, poster: film37 },
        { id: 38, poster: film38 },
    ];


    return(
        <>
        <section className="series-section relative overflow-hidden">
            {/* Background Pattern */}
            <div className="absolute inset-0 opacity-20">
                    <div className="h-64 w-full" style={{
                        backgroundImage: `radial-gradient(circle, #3b82f6 1px, transparent 1px)`,
                        backgroundSize: '20px 20px'
                    }}></div>
                </div>
            <div className="main-content w-[90%] sm:w-[90%] md:w-[85%] m-auto">
            <div className="text-center mt-12">
                <h1 className="text-2xl md:text-3xl lg:text-4xl mx-auto font-extrabold text-blue-900 mb-4 max-w-3xl leading-snug text-center">
                    Streaming illimité des derniers films, séries et chaînes de télévision en direct
                </h1>
                <p className="text-lg text-gray-600 max-w-2xl mx-auto">
                    Profitez du contenu premium des meilleures plateformes de streaming avec un seul abonnement
                </p>
            </div>
            {/* Films Carousel - Left to Right */}
            <div className="mt-5">
                <div className="relative overflow-hidden">
                    <div className="flex space-x-6 pb-5 carousel-films">
                        {[...films, ...films, ...films].map((film, index) => (
                            <div key={`${index}-${Math.random()}`} className="flex-shrink-0 carousel-item">
                                <div className="relative w-48 h-80 rounded-lg overflow-hidden shadow-lg">
                                    <img 
                                        src={film.poster}
                                        alt={film.id}
                                        className="w-full h-full object-cover carousel-image"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            {/* Channels Carousel - Right to Left */}
            <div className="mt-5"> 
                <div className="relative overflow-hidden">
                    <div className="flex space-x-8 carousel-channels">
                        {[...channels, ...channels, ...channels].map((channel, index) => (
                            <div key={`${index}-${Math.random()}`} className="flex-shrink-0 flex items-center justify-center carousel-item">
                                <div className="w-24 h-16 flex items-center justify-center p-2">
                                    <img 
                                        src={channel.logo} 
                                        alt={channel.name}
                                        className="max-w-full max-h-full object-contain carousel-image"
                                    />
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
            </div>
        </section>
        </>
    )
}